import { render, staticRenderFns } from "./MTopButton.vue?vue&type=template&id=1b941cec&scoped=true&"
import script from "./MTopButton.vue?vue&type=script&lang=js&"
export * from "./MTopButton.vue?vue&type=script&lang=js&"
import style0 from "./MTopButton.vue?vue&type=style&index=0&id=1b941cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b941cec",
  null
  
)

export default component.exports